import Vue from "vue"
import moment from "moment"

// Возрастная группа по дате рождения НА ДАТУ ЗАЕЗДА: '0' — 14+, '1' — [3,14), '2' — <4.
// Если день рождения не заполнен — откат на выбранный вручную guestType.
function effectiveGuestType(guest, dateIn) {
  if (!guest.birthday || !dateIn) return String(guest.guestType)
  const bd = moment(guest.birthday, 'YYYY-MM-DD')
  if (!bd.isValid()) return String(guest.guestType)
  const din = moment(dateIn, 'YYYY-MM-DD')
  if (!din.isValid()) return String(guest.guestType)
  const age = din.diff(bd, 'years')
  if (age >= 14) return '0'
  if (age >= 4) return '1'
  return '2'
}

export const guestsModule = {
  state: () => ({
    purchaser: {
      /**
      secondName: "Петров",
      firstName: "Василий",
      thirdName: "Николаевич",
      birthday: '1980-10-20',
      email: "dead@inside.com",
      phone: "+7 (982) 222-33-44",
      guestId: null, //
      isNotGuest: true, // Не является ли гостем (если нет - есть параметр guestId)
       */
    },

    guestsList: [
      // {
      //   id: 1,
      //   isPurchaser: true,
      //   seat: 1,
      //   seatExtra: 0,
      //   firstName: 'Василий',
      //   secondName: 'Петров',
      //   thirdName: 'Николаевич',
      //   isNoThirdName: false,
      //   guestType: '0', // TODO: 0 - adult, 1 - child, 2 - baby
      //   birthday: '1980-10-20',
      //   gender: 'male',
      //   email: null,
      //   phone: '+7 (982) 222-33-44',
      //   nutrition: '1',
      //   nutritionSum: 0,
      //   cure: '1',
      //   cureSum: 0,
      //   healthcard: false,
      //   healthcardSum: 0,
      //   accommodationSum: 0,
      //   totalSum: 0,
      //   isPersonalCompleted: true,
      // }
    ],

    extraServices: [
      {
        id: 1645,
        title: 'Парковка',
        isSelected: false,
        dateStart: null,
        dateEnd: null,
        // daysCnt: null,
        additional: null,
        totalPrice: 0,
        cnt: 1,
      }
    ],

    commonFields: {
      nutrition: null,
      cure: null,
    }
  }),

  getters: {
    getGuestsList: state => {
      return state.guestsList
    },

    getPurchaser: state => {
      return state.purchaser
    },

    getGuestIndex: state => id => {
      return state.guestsList.findIndex(obj => obj.id === id)
    },

    getGuestField: state => (id, fieldName = '') => {
      return state.guestsList.find(obj => obj.id === id)[fieldName]
    },

    getGuestFields: state => (id, fieldNames = []) => {
      let guest = state.guestsList.find(obj => obj.id === id)

      if(fieldNames.length > 0) {
        let filteredGuest = {}
        fieldNames.forEach(name => filteredGuest[name] = guest[name])
        return filteredGuest
      } else {
        return guest
      }
    },

    getGuestsFields: state => (fieldNames = []) => {
      return state.guestsList.map(guest => {
        let tempGuest = {}
        fieldNames.forEach(i => {
          tempGuest[i] = guest[i]
        })
        return tempGuest
      })
    },

    getFilteredGuestsFields: state => (fields = [], filterBy = {}) => {
      let guests = state.guestsList.reduce((acc, cur) => {
        if(Object.keys(filterBy).length > 0) {
          for (let field in filterBy) {
            if (filterBy[field] !== cur[field]) return acc
          }
        }

        let temp = {}

        if(fields.length > 0) {
          fields.forEach((fieldName) => {
            temp[fieldName] = cur[fieldName]
          })
        } else {
          for(let fieldName in cur) {
            temp[fieldName] = cur[fieldName]
          }
        }

        acc.push(temp)
        return acc
      }, [])
      return guests
    },

    getCommonField: state => (fieldName = '') => {
      return state.commonFields[fieldName]
    },

    getCommonFields: state => () => {
      return state.commonFields
    },

    getMaxId: state => {
      return state.guestsList.length > 0 ?
        state.guestsList.reduce((acc, curr) => acc.id > curr.id ? acc : curr).id
        : 0
    },

    getTotalPrice: state => {
      return state.guestsList.reduce((acc, cur) => {
        acc += +cur.price
        return acc
      }, 0)
    },

    // getSelectedExtraServices: state => {
    //   return state.extraServices.filter(obj => obj.isSelected === true)
    // },

    // getComplitedGuests: state => (fields = []) => {
    //   return state.guestsList.reduce((acc, cur) => {
    //     let isCurComplete = true

    //     if(fields.length > 0) {
    //       fields.forEach(field => {
    //         if(cur[field] === null || cur[field] === undefined || cur[field].trim() === '') isCurComplete = false
    //       })
    //     } else {
    //       for(let field in cur) {
    //         if(cur[field] === null || cur[field] === undefined || cur[field].trim() === '') isCurComplete = false
    //       }
    //     }

    //     if(isCurComplete) acc.push(cur.id)
    //     return acc
    //   }, [])
    // },
  },

  mutations: {
    addGuest(state, payload) {
      state.guestsList.push(payload)
    },

    removeGuest(state, id) {
      const index = state.guestsList.findIndex(n => n.id === id);
      if (index !== -1) {
        state.guestsList.splice(index, 1);
      }
    },

    resetGuests(state) {
      Vue.set(state, 'guestsList', []);
    },

    updateGuest(state, payload) {
      let guestObjIndex = state.guestsList.findIndex((obj) => {
        return obj.id == payload.id
      })

      if(guestObjIndex === -1) {
        console.error('Гость с таким id не найден.')
        return false
      }

      Object.assign(state.guestsList[guestObjIndex], payload.obj);
    },

    updateAllGuests(state, payload) {
      state.guestsList.forEach(obj => {
        Object.assign(obj, payload)
      })
    },

    setPurchaser(state, purchaser) {
      state.purchaser = purchaser;
    },

    /**
     * @deprecated
     * @param state
     * @param payload
     */
    // setPurchaser(state, payload) {
    //   if(state.guestsList.find(obj => obj.id === payload.id).guestType === '0') {
    //     let curPurchaserIndex = state.guestsList.findIndex(obj => obj.isPurchaser === true)
    //     if(curPurchaserIndex >= 0) {
    //       state.guestsList[curPurchaserIndex].isPurchaser = false
    //     }
    //     state.guestsList.find(obj => obj.id === payload.id).isPurchaser = payload.value
    //   }
    // },

    updateCommonFields(state, payload) {
      Object.assign(state.commonFields, payload);
    },

    // updateExtraService(state, payload) {
    //   let findedObj = state.extraServices.find(obj => obj.id === payload.id)
    //   if(findedObj) {
    //     Object.assign(findedObj, payload.data);
    //   }
    // },
  },

  actions: {
    checkGuestsComplete({state, commit}) {
      let bool = false

      switch(state.bookingStep) {
        case 2:
          let filteredArr = state.guestsList.filter(obj => {
            return (
              obj.firstName
              && obj.secondName
              && obj.guestType
              && obj.birthday
              && obj.gender
              && obj.email
              && obj.phone
              && ((!obj.isNoThirdName && obj.thirdName) || obj.isNoThirdName)
            )
          })

         // let isPurchaserSetted = state.guestsList.filter(obj => obj.isPurchaser).length > 0

          // console.log(filteredArr)
          // console.log(isPurchaserSetted)
          break

        case 3:
          break

        default:
          break
      }

      commit('setGuestsComplete', bool)
    },

    selectPurchaser({commit, getters}, {purchaser}) {
      let isNotGuest = purchaser.isNotGuest;
      if (isNotGuest) {
        purchaser.guestId = null;
      }
      else {
        if (!purchaser.guestId) throw new Error("Guest id is not defined");
        let purchaserGuestObj = getters.getGuestsList[getters.getGuestIndex(purchaser.guestId)];

        for (const purchaserKey of Object.keys(purchaser)) {
          if (!purchaserGuestObj.hasOwnProperty(purchaserKey)) continue;
          purchaser[purchaserKey] = purchaserGuestObj[purchaserKey];
        }
      }

      commit('setPurchaser', purchaser);
    },

    // createGuest(id) {
    //   let guest = {
    //     id: id,
    //     seat: 1,
    //     seatExtra: 0,
    //     isPurchaser: false,
    //     firstName: null,
    //     secondName: null,
    //     thirdName: null,
    //     isNoThirdName: false,
    //     guestType: rootGetters['dictionaries/getDefaultGuestType'], // TODO: 0 - adult, 1 - child, 2 - baby
    //     birthday: null,
    //     gender: 'male',
    //     email: null,
    //     phone: null,
    //     nutrition: rootState.selection.defaults.nutrition,
    //     // nutritionSum: 0,
    //     cure: rootState.selection.defaults.cure,
    //     // cureSum: 0,
    //     healthcard: false,
    //     // healthcardSum: 0,
    //     // accommodationSum: 0,
    //     totalSum: 0,
    //     isPersonalCompleted: false,
    //     passport: {
    //       series: '0000',
    //       number: '000000',
    //       issueDate: '2022-01-01',
    //       issueDepartment: 'отделением УВД Ленинского р-на города Перми',
    //       issueDepartmentCode: '590-344',
    //     },
    //     address: {
    //       region: '4f8b1a21-e4bb-422f-9087-d3cbf4bebc14',
    //       regionName: 'Пермский край',
    //       city: '4ffcde97-05e9-4a6e-bd51-3a984b41b7bd',
    //       cityName: 'г Березники',
    //       street: '33b6d40d-1030-492d-9238-ed838731de4e',
    //       streetName: 'пр-кт Ленина',
    //       house: '2d446b12-52da-490a-ac24-bca77650f2a2',
    //       houseName: '24',
    //       flat: '23',
    //     },
    //   }

    //   return guest
    // },

    addGuest({dispatch, getters, commit, rootGetters, rootState}, data = {}) {
      let maxId = getters.getMaxId
      // let selectedVariant = rootGetters['selection/getSelectedVariant']

      // console.log(selectedVariant)
      // return

      let obj = {
        id: +maxId + 1,
        seat: 1,
        seatExtra: 0,
        isPurchaser: false,
        firstName: null,
        secondName: null,
        thirdName: null,
        isNoThirdName: false,
        guestType: rootGetters['dictionaries/getDefaultGuestType'], // TODO: 0 - adult, 1 - child, 2 - baby
        birthday: null,
        gender: null,
        email: null,
        phone: null,
        nutrition: rootState.selection.defaults.nutrition,
        // nutritionSum: 0,
        cure: rootState.selection.defaults.cure,
        // cureSum: 0,
        healthcard: false,
        // healthcardSum: 0,
        // accommodationSum: 0,
        price: 0,
        isPersonalCompleted: false,
        passport: {
          series: '0000',
          number: '000000',
          issueDate: '2022-01-01',
          issueDepartment: 'отделением УВД Ленинского р-на города Перми',
          issueDepartmentCode: '590-344',
        },
        address: {
          region: '4f8b1a21-e4bb-422f-9087-d3cbf4bebc14',
          regionName: 'Пермский край',
          city: '4ffcde97-05e9-4a6e-bd51-3a984b41b7bd',
          cityName: 'г Березники',
          street: '33b6d40d-1030-492d-9238-ed838731de4e',
          streetName: 'пр-кт Ленина',
          house: '2d446b12-52da-490a-ac24-bca77650f2a2',
          houseName: '24',
          flat: '23',
        },
      }

      commit('addGuest', {...obj, ...data})
      dispatch('recalculateGuestsSeats')
      dispatch('calcGuestPrice', obj.id)
      // dispatch('checkGuestsComplete')

      // return obj.id
    },

    removeGuest({dispatch, commit}, id) {
      commit('removeGuest', id)
      dispatch('recalculateGuestsSeats')
      // dispatch('checkGuestsComplete')
    },

    updateGuest({commit, dispatch}, payload) {
      const recalcTriggerFields = [
        'guestType',
        'gender',
        'nutrition',
        'cure',
        'healthcard',
        'birthday'
      ]
      let recalcTrigger = false

      commit('updateGuest', payload)
      dispatch('recalculateGuestsSeats')

      // калькуляция цен

      Object.keys(payload.obj).forEach(field => {
        if(recalcTriggerFields.findIndex(triggerField => triggerField === field) !== -1) {
          recalcTrigger = true
        }
      })

      if(recalcTrigger) {
        dispatch('calcGuestPrice', payload.id)
      }
      // console.log(editableFields)
      // dispatch('checkGuestsComplete')
    },

    updateAllGuests({state, commit, dispatch}, payload) {
      // commit('updateAllGuests', payload)
      state.guestsList.forEach(guest => {
        dispatch('updateGuest', {
          id: guest.id,
          obj: payload,
        })
      })
      // dispatch('checkGuestsComplete')
    },

    calcGuestPrice({state, commit, rootState}, id) {
      let guest = state.guestsList.find(obj => obj.id === id),
          checkoutTimeActive = rootState.selection?.checkoutTime

      if (!checkoutTimeActive) checkoutTimeActive = rootState.dictionaries?.checkoutTime?.find(item => item?.default === true)

      /*
        костыль, если др не заполнено, то подставлять дефолтный по типу гостя
        нужно для правильного рассчета цены
      */
      let birthday = guest.birthday
      if(!birthday) {
        switch(guest.guestType) {
          case '1':
            birthday = new Date(new Date().setYear(new Date().getFullYear()-5)).toISOString().substring(0,10)
            break

          case '2':
            birthday = new Date().toISOString().substring(0,10)
            break
        }
      }

      let reqBody = {
        dateIn: rootState.selection.dateIn,
        dateOut: rootState.selection.dateOut,
        checkoutTime: checkoutTimeActive,
        roomCategory: rootState.selection.selectedCategoryId,
        guest: {
          primary: guest.isPurchaser,
          person: {
            lastName: guest.secondName,
            name: guest.firstName,
            secondName: guest.isNoThirdName ? null : guest.thirdName,
            birthday: birthday,
            phone: guest.phone || null,
            email: guest.email || null,
            guestType: guest.guestType,
            gender: guest.gender,
            seat: guest.seat,
            seat_extra: guest.seatExtra,
            passport: {},
            address: {}
          },
          cure: guest.cure,
          nutrition: guest.nutrition,
          healthCard: guest.healthcard,
        }
      }

      // console.log(reqBody)

      this._vm.$http
        .post('/search/calculateByGuest/', reqBody)
        .then(resp => {
          // console.log(id)

          // console.log(resp.data.result)
          let payload = resp.data.data
          commit('updateGuest', {
            id: id,
            obj: {
              price: payload.price,
            },
          })
        })
        .catch(e => {
          console.error(e)
        })
        .finally(() => {

        })
    },

    recalculateGuestsSeats({state, dispatch, getters, commit, rootGetters, rootState}) {
      let selectedVariantCapacity = rootGetters['selection/getSelectedCategory'].capacity
      // getDateIn — обычный геттер (не фабрика), возвращает 'YYYY-MM-DD'
      let dateIn = rootGetters['selection/getDateIn']
      let countSeat = 0
      let arSeat = []
      let arSeatExtra = []
      let countAdult = 0

      // тип гостя для раздачи мест определяем по дате рождения на дату заезда,
      // а не по вручную выставленному guestType (Б24 39501)
      state.guestsList.forEach((guest, i) => {
        if (effectiveGuestType(guest, dateIn) === '0') {
          countAdult = countAdult + 1
        }
      })
      state.guestsList.forEach((curGuest, i) => {
        let curGuestType = effectiveGuestType(curGuest, dateIn)
        if (curGuestType == '1' && selectedVariantCapacity == 2 && countAdult < 2) {
          arSeat[i] = 1
          arSeatExtra[i] = 0
        } else if (curGuestType != '0') {
          arSeat[i] = 0
          arSeatExtra[i] = 1
        } else {
          arSeat[i] = 1
          arSeatExtra[i] = 0
        }
        if (arSeat[i] == 1) {
          countSeat = countSeat + 1
        }
        if (countSeat > selectedVariantCapacity) {
          arSeat[i] = 0
          arSeatExtra[i] = 1
        }
        commit('updateGuest', {
          id: curGuest.id,
          obj: {
            seat: arSeat[i],
            seatExtra: arSeatExtra[i],
          },
        })
      })
    },

    updateCommonFields({commit, dispatch}, payload) {
      commit('updateCommonFields', payload)
    },

    checkIsPersonalCompleted({state, commit}, id) {
      let guest = state.guestsList.find(obj => obj.id === id)
      let isCompleted = true
      const requiredFields = [
        'firstName',
        'secondName',
        'thirdName',
        'isNoThirdName',
        'guestType',
        'birthday',
        'gender',
        'phone',
      ]

      requiredFields.forEach(field => {
        if(!guest.hasOwnProperty(field)) {
          // console.log(`${field} `)
          return
        }

        if(field === 'thirdName' && guest['isNoThirdName']) {
          return
        }

        if(
          guest[field] === null
          || guest[field] === undefined
          || typeof(guest[field]) === 'string' && guest[field].trim() === ''
        ) {
          isCompleted = false
        }
      })

      if(isCompleted) {
        if(!guest.isPersonalCompleted) {
          commit('updateGuest', {
            id: guest.id,
            obj: { 'isPersonalCompleted': true },
          })
        }
      } else {
        if(guest.isPersonalCompleted) {
          commit('updateGuest', {
            id: guest.id,
            obj: { 'isPersonalCompleted': false },
          })
        }
      }

      // console.log(isCompleted)
      // console.log(`id ${id} is completed: ${state.guestsList.find(obj => obj.id === id).isPersonalCompleted}`)
    },

    // updateExtraService({commit}, payload) {
    //   commit('updateExtraService', payload)
    // }
  },

  namespaced: true,
}
